import { animate, style, transition, trigger } from '@angular/animations';

export const ScaleAnimation = trigger('scale', [
  transition(':enter', [style({ transform: 'scale(0)' }), animate('200ms ease-in-out', style({ transform: '*' }))]),
  transition(':leave', animate('200ms ease-in-out', style({ transform: 'scale(0)' }))),
]);
